/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import {useMemo} from 'react'
import {UiSelectOption} from 'components/Ui/UiSelect'

const defaultPositions = [
    'Geschäftsführung/Inhaber',
    'GL-Assistenz/Eventmanagement',
    'Office-Management/Administration',
    'Teamleitung/Abteilungsleitung',
    'Teammitglied',
    'Lehrling',
    'Lehrperson/Schulleitung',
    'Privatperson/Vereinsmitglied',
]

const useCompanyPositionOptions = (otherLabel: string) => {
    return useMemo<UiSelectOption[]>(() => {
        return [
            ...defaultPositions.map((pos) => ({ value: pos, label: pos })),
            { value: 'custom', label: otherLabel },
        ]
    }, [otherLabel])
}

export default useCompanyPositionOptions
export { defaultPositions }
